import Fuse from 'fuse.js'

export default (searchKeys = [], perPage = 25) => ({
	data() {
		return {
			pagination: {
				perPage: perPage,
				currentPage: 1,
				perPageOptions: [5, 25, 50, 100, 500],
				total: 0,
			},
			tableData: [],
			searchQuery: '',
			searchedData: [],
			fuseSearch: null,
		}
	},
	computed: {
		queriedData() {
			let result = this.tableData
			if (this.searchedData.length > 0) {
				result = this.searchedData
			} else {
				if (this.searchQuery) {
					result = []
				}
			}
			return result.slice(this.from, this.to)
		},
		to() {
			let highBound = this.from + this.pagination.perPage
			if (this.total < highBound) {
				highBound = this.total
			}
			return highBound
		},
		from() {
			return this.pagination.perPage * (this.pagination.currentPage - 1)
		},
		total() {
			return this.searchedData.length > 0 ? this.searchedData.length : this.tableData.length
		},
	},
	methods: {
		sortChange({ prop, order }) {
			if (prop) {
				this.tableData.sort((a, b) => {
					let aVal = a[prop]
					let bVal = b[prop]

					if (order === 'ascending') {
						return aVal > bVal ? 1 : -1
					}
					return bVal - aVal ? 1 : -1
				})
			} else {
				this.tableData.sort((a, b) => {
					return a.id - b.id
				})
			}
		},
		updateTableData(data) {
			this.tableData = data
			this.fuseSearch = new Fuse(data, {
				keys: searchKeys,
				threshold: 0.3,
			})
		},
	},
	watch: {
		searchQuery(val) {
			let result = this.tableData
			if (val !== '' && this.fuseSearch) {
				result = this.fuseSearch.search(this.searchQuery)
			}
			this.searchedData = result
		},
	},
})
